export const getCurrentUrl = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${window.location.pathname}`
  }
}
